<div class="app-tab-item-content">
    <ng-content></ng-content>
</div>
